var React = require('react');
var mui = require('material-ui');
var PayloadStates = require('../constants/PayloadStates');
import {green300, grey300, red300} from 'material-ui/styles/colors';

module.exports = lore.connect(function(getState, props) {
  return {
    server: getState('server.byId', {
      id: 1247
    })
  }
})(
  React.createClass({
    displayName: 'Server',

    propTypes: {
      server: React.PropTypes.object.isRequired,
      isTesting: React.PropTypes.bool.isRequired,
      onTestComplete: React.PropTypes.func.isRequired,
    },

    componentWillReceiveProps: function(nextProps) {
      var server = nextProps.server;

      if (this.props.server.state === PayloadStates.FETCHING && server.state !== PayloadStates.FETCHING) {
        this.props.onTestComplete(server, server.state === PayloadStates.ERROR_FETCHING)
      }
    },

    render: function() {
      var isTesting = this.props.isTesting;
      var server = this.props.server;
      var testingComplete = server.state !== PayloadStates.FETCHING;
      var completed = testingComplete ? 1 : 0;
      var failed = server.state === PayloadStates.ERROR_FETCHING ? 1 : 0;

      var backgroundColor = grey300;

      var avatar = isTesting ? (
          <mui.CircularProgress />
        ) : (
          <mui.Avatar backgroundColor={backgroundColor}>
            ?
          </mui.Avatar>
        );

      if (completed) {
        if (failed > 0) {
          backgroundColor = red300;
          avatar = (
            <mui.Avatar
              backgroundColor={backgroundColor} />
          );
        } else {
          backgroundColor = green300;
          avatar = (
            <mui.Avatar
              backgroundColor={backgroundColor} />
          );
        }
      }

      var primaryText = isTesting ? (
          completed + ' of 1 tests complete / ' + failed + ' failed'
        ) : 'Waiting to begin test...';

      return (
        <mui.Paper>
          <mui.List>
            <mui.ListItem
              disabled={true}
              leftAvatar={avatar}
              primaryText={primaryText}
              secondaryText={(
                <mui.LinearProgress
                  mode="determinate"
                  color={testingComplete ? backgroundColor : null}
                  style={{height: '4px', marginTop: '8px'}}
                  min={0}
                  max={1}
                  value={completed} />
              )}
            />
          </mui.List>
        </mui.Paper>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/Server.js